export default __webpack_public_path__ + "static/media/icons8-remove.748f2be2.svg";